// Version : 1.0.0
// Author : AGALYA

import PersonalDetailsActionType from './personal-details.types';

/** ***************** Personal Details Add Start ************************/
export const personalDetailsStart = (signatureUploadCredentials: any) => ({
	type: PersonalDetailsActionType.PERSONAL_DETAILS_START,
	payload: signatureUploadCredentials,
});

export const personalDetailsSuccess = (signatureUploadSuccess: any) => ({
	type: PersonalDetailsActionType.PERSONAL_DETAILS_SUCCESS,
	payload: signatureUploadSuccess,
});

export const personalDetailsFailure = (signatureUploadFailure: any) => ({
	type: PersonalDetailsActionType.PERSONAL_DETAILS_FAILURE,
	payload: signatureUploadFailure,
});

export const personalDetailsResponseResetStart = () => ({
	type: PersonalDetailsActionType.PERSONAL_DETAILS_RESPONSE_REST_START,
});

export const personalDetailsUserResponseChanged = () => ({
	type: PersonalDetailsActionType.PERSONAL_DETAILS_RESPONSE_CHANGED,
});
/** ***************** Personal Details Add End ************************/
